import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export const EXCLUIR_CUSTO_ITINERARIO = '@excluirCustoItinerario/EXCLUIR_CUSTO_ITINERARIO';

export default function excluirCustoItinerario (idCustoItinerario, empresaId, usuarioId) {
  const url = `${URL}/itinerario/empresa/${empresaId}/usuario/${usuarioId}/custo-itinerario/${idCustoItinerario}/excluir`;
  return dispatch => axios.post(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: EXCLUIR_CUSTO_ITINERARIO,
      payload: response
    })
  );
}